import {Button} from "./Button";
import {formatBalance} from "../utils";
import tokenIcon from "../assets/logos/grove@2x.png";
import classNames from "classnames";

export const PurchaseButton = ({onClick, text, price, disabled}) => {
    return (
        <div className={classNames('PurchaseButton', {
            ['PurchaseButton--disabled']: disabled,
        })}
             onClick={disabled ? null : onClick}>
            <div className={'PurchaseButton__price-wrapper'}>
                <img src={tokenIcon}
                        className={'PurchaseButton__price-icon'}
                />
                <div className={'PurchaseButton__price'}>
                    {price === 0 ? 'FREE' : price}
                </div>
            </div>
            <Button color={'red'}
                    disabled={disabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        if(onClick) {
                            onClick();
                        }

                    }}>
            {text}
            </Button>
        </div>
    )
}

export default PurchaseButton;